"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var groupReviewListConfig = function groupReviewListConfig(dataSource) {
  var columns = [{
    title: 'Patient Name',
    dataIndex: 'patientName',
    key: 'patientName',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.patientName);
    }
  }, {
    title: 'Therapist Name',
    dataIndex: 'therapistName',
    key: 'therapistName',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.therapistName);
    }
  }, {
    title: 'Session Date',
    dataIndex: 'sessionDate',
    key: 'sessionDate',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.formatDate)(record.sessionDate, {
        withTime: true
      }));
    }
  }, {
    title: 'Capacity',
    dataIndex: 'capacity',
    key: 'capacity',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.capacity);
    }
  }, {
    title: 'Question',
    dataIndex: 'question',
    key: 'question',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.question);
    }
  }, {
    title: 'Rating',
    dataIndex: 'rating',
    key: 'rating',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.rating);
    }
  }, {
    title: 'Review',
    dataIndex: 'review',
    key: 'review',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.review);
    }
  }, {
    title: 'Allow to use',
    dataIndex: 'allowToUse',
    key: 'allowToUse',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.allowToUse || 'no review');
    }
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id'
  };
};
var _default = groupReviewListConfig;
exports.default = _default;